<template>
    <AppLayout>
        <div class="container p-4 mx-auto md:px-1 md:py-4">
            <!-- breadcrumb -->
            <nav
                class="mb-6 text-sm font-semibold"
                aria-label="Breadcrumb"
            >
                <ol class="inline-flex p-0 list-none">
                    <li class="flex items-center text-blue-500">
                        <inertia-link
                            :href="route('landing')"
                            class="text-gray-600"
                        >
                            Home
                        </inertia-link>
                        <svg
                            fill="#34D399"
                            class="w-3 h-3 mx-3 "
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 320 512"
                        >
                            <path
                                d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
                            />
                        </svg>
                    </li>
                    <li class="flex items-center">
                        <a
                            href="#"
                            class="text-gray-600"
                        >Invoices for Dispatch</a>
                    </li>
                </ol>
            </nav>
            <div class="w-1/3 mb-6">
                <t-input
                    id="order-number-search-box"
                    v-model="search"
                    placeholder="Search by order number"
                    @keypress.enter="fetchPageData()"
                />
            </div>
            <!-- breadcrumb end -->
            <t-table
                v-if="packedInvoices.length"
                :responsive="true"
                :responsive-breakpoint="640"
                :headers="['Retailer Name', 'Order Number', 'Total Amount', 'Date', 'Terms of Payment']"
            >
                <template
                    slot="tbody"
                    slot-scope="props"
                >
                    <tr
                        v-for="invoice in packedInvoices"
                        :key="'invoice-' + invoice.id"
                        :class="[props.trClass, 'cursor-pointer']"
                        @click="goto('invoice.dispatch.show', { billNo: invoice.bill_number })"
                    >
                        <!-- Retailer Name -->
                        <td :class="props.tdClass">
                            {{ invoice.user.name }}
                        </td>
                        <td :class="props.tdClass">
                            {{ invoice.bill_number }}
                        </td>
                        <td :class="props.tdClass">
                            {{ config(common.currency) }} {{ getTotalAmount(invoice.transactions) }}
                        </td>
                        <td :class="props.tdClass">
                            {{ invoice.created_at | fromNow }}
                        </td>
                        <td :class="props.tdClass">
                            {{ invoice.payment_method }}
                        </td>
                    </tr>
                </template>
            </t-table>

            <div class="my-4">
                <t-pagination
                    v-model="currentPage"
                    :total-items="totalRows"
                    :per-page="perPage"
                    :limit="limit"
                    :disabled="disabled"
                    @change="fetchPageData"
                />
            </div>
        </div>
    </AppLayout>
</template>

<script>
import _ from 'lodash';
import AppLayout from '../../Layouts/AppLayout.vue';
import common from '../../common';

export default {
    name: 'InvoicesForDispatch',

    components: { AppLayout },

    props: {
        invoices: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            common,

            currentPage: null,
            limit: 5,
            perPage: this.invoices.per_page,
            totalRows: this.invoices.total,
            search: null,
            mounted: false,
        };
    },

    computed: {
        packedInvoices() {
            return this.invoices.data ?? [];
        },

        disabled() {
            return !this.invoices.data.length;
        },
    },

    created() {
        if (this.keyword) this.search = this.keyword;
        this.currentPage = this.invoices.current_page;

        this.debouncedFetchPageData = _.debounce(this.fetchPageData, 2000);

        this.$nextTick(() => {
            this.mounted = true;
        });
    },

    methods: {
        fetchPageData(newPage = 1) {
            this.$inertia.get(
                route('invoice.dispatch', {
                    page: newPage,
                    keyword: this.search,
                })
            );
        },

        getTotalAmount(transactions) {
            return transactions.reduce((acc, tran) => (acc += parseFloat(tran.grand_total)), 0);
        },

        showInvoiceDetail() {},
    },
};
</script>

<style></style>
